import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import LiveSubjectTable from './LiveSubjectTable';
const LiveSubject = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Live Subject' parent='Live Subject'  />
      <Container fluid={true}>
        <Row>
          <LiveSubjectTable  />
        </Row>
      </Container>
    </Fragment>
  );
};

export default LiveSubject;
